import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import {
  classLearner,
  eExaminationGetMyExaminerProfile,
} from '../../../utils/apiPath'

export const getRegistrationDetail = createAsyncThunk(
  'getRegistrationDetail',
  async ({ uuid, classLearnerUuid }, { rejectWithValue }) => {
    try {
      if (!classLearnerUuid) classLearnerUuid = false
      const response = await axios.get(
        `${classLearner}/${uuid}/${classLearnerUuid}`
      )

      return response
    } catch (err) {
      return rejectWithValue([], err)
    }
  }
)

export const fetchMyEnrollProfile = createAsyncThunk(
  'classEnroll/fetchMyEnrollProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(eExaminationGetMyExaminerProfile)
      const { data } = response
      return data
    } catch (err) {
      return rejectWithValue([], err)
    }
  }
)
